// extracted by mini-css-extract-plugin
export default {"container":"map_container__AnOOo","blok":"map_blok__yhcHG","h3":"map_h3__QoVl2","button":"map_button__n4mFe","vector":"map_vector__iqoBa"};